export const paginationStyles = {
  display: 'flex',
  width: '100%',
  listStyle: 'none',
  paddingY: 2,
  paddingX: 0,
  justifyContent: 'flex-end',
  backgroundColor: 'white',
  borderTop: '1px solid',
  borderTopColor: 'gray.100',
  left: 0,
  bottom: 0,
  position: 'fixed',
  '.rc-pagination': {
    '&-item': {
      outline: 0,
      display: 'flex',
      cursor: 'pointer',
      paddingY: 0,
      paddingX: 4,
      listStyle: 'none',
      userSelect: 'none',
      borderRadius: '4px',
      textAlign: 'center',
      minHeight: 10,
      alignItems: 'center',
      marginRight: 2,
      backgroundColor: 'transparent',
      a: {
        fontWeight: 500,
        textDecoration: 'none',
        color: 'gray.700',
      },
      '&:hover > a': {
        fontWeight: 600,
        color: 'black',
      },
      '&-active': {
        backgroundColor: 'gray.100',
        a: {
          color: 'black',
        },
      },
    },
    '&-prev, &-next, &-jump-prev, &-jump-next': {
      outline: 0,
      cursor: 'pointer',
      listStyle: 'none',
      textAlign: 'center',
      borderRadius: '4px',
      minWidth: 10,
      marginRight: 2,
    },
    '&-next, &-prev': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'gray.100',
      i: {
        pointerEvents: 'none',
      },
    },
    '&-jump-prev, &-jump-next': {
      marginRight: 0,
      _after: {
        content: `'...'`,
        display: 'block',
        fontSize: 10,
        fontWeight: 'bold',
        letterSpacing: '2px',
        color: 'black',
      },
    },
    '&-disabled': {
      cursor: 'default',
      backgroundColor: 'gray.50',
      i: {
        color: 'gray.300',
      },
    },
  },
};
